import { Form } from "react-bootstrap";
import { UseFormRegisterReturn } from "react-hook-form";
import RequiredStar from "../RequiredStar";
import { SelectOption } from "@/shared/models/ui-using/SelectOption";

interface FormGroupSelectProps {
  label: string;
  required?: boolean;
  options: string[] | SelectOption[];
  register: UseFormRegisterReturn;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
  showUnknownValue?: boolean;
}

export default function FormGroupSelect({
  label,
  required = false,
  options,
  register,
  disabled = false,
  onChange,
  value,
  showUnknownValue = true,
}: FormGroupSelectProps) {
  const isSelectOptionArray = (opts: string[] | SelectOption[]): opts is SelectOption[] => {
    return opts.length > 0 && typeof opts[0] === "object" && "value" in opts[0];
  };

  const isValueInOptions = (): boolean => {
    if (!value) return true;
    if (isSelectOptionArray(options)) {
      return options.some((opt) => opt.value === value);
    }
    return (options as string[]).includes(value);
  };

  const showExtraOption = showUnknownValue && !!value && !isValueInOptions();

  return (
    <Form.Group className="mb-2">
      <Form.Label>
        {label} {required && <RequiredStar />}
      </Form.Label>
      <Form.Select
        {...register}
        required={required}
        disabled={disabled}
        onChange={(event) => {
          register.onChange(event);
          onChange?.(event);
        }}
      >
        <option value="">Select {label}...</option>
        {showExtraOption && (
          <option key={value} value={value}>
            {value}
          </option>
        )}
        {isSelectOptionArray(options)
          ? options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))
          : options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
      </Form.Select>
    </Form.Group>
  );
}
